import { Injectable } from '@angular/core';
import { BackendRerouteService, Invoice } from 'gung-standard';
import { Observable, switchMap } from 'rxjs';
import { ActionButton, ActionButtonConfigService, GungBackendFeatureService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class JeevesInvoiceActionConfigService implements ActionButtonConfigService<Invoice> {
  base = [
    // { title: 'PDF', action: (item: Invoice) => this.backendRerouteService.reroute('download/order-pdf/' + item.id) }
  ];

  constructor(
    protected backendRerouteService: BackendRerouteService,
    protected gungBackendFeatureService: GungBackendFeatureService
  ) { }

  getButtons(item: Invoice): Observable<ActionButton<Invoice>[]> {
    return this.gungBackendFeatureService.isActivated('gung-erp-jeeves-cloud').pipe(
      switchMap(isErpJeevesCloud => {
        if (isErpJeevesCloud) {
          this.base = [
            { title: 'PDF', action: (item: Invoice) => this.backendRerouteService.reroute('download/invoice-pdf/' + item.id + '.pdf') }
          ];
        }
        return new Observable<ActionButton<Invoice>[]>(subscriber => {
          subscriber.next(this.base);
          subscriber.complete();
        });
      })
    );
  }
}
